import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { default as config } from '../../../utilities/config';

import {
  Button,
  Card,
  DataTable,
  DataTableColumn,
  DataTableCell,
  MediaObject,
  Spinner
} from '@salesforce/design-system-react';

import './ReportList.scss';

const CustomDataTableCell = ({ children, property, ...props }) => (
  <td>{children}</td>
);

CustomDataTableCell.displayName = DataTableCell.displayName;
CustomDataTableCell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  property: PropTypes.string.isRequired,
  formatMessage: PropTypes.func,
  item: PropTypes.object
};

class ReportList extends Component {
  headerCell(property, formatMessage) {
    return formatMessage({ id: `components.ecs.reports.${property}` });
  }

  columns() {
    return {
      date: { sortable: true, width: '20%' },
      download: { sortable: false }
    };
  }

  tableData(items) {
    if (!items) {
      return [];
    }
    const reportHref = `${
      config.serverUrl['metalMastodon']
    }ecs/api/report/selection_click/`;
    return items.map(item => ({
      ...item,
      date: item,
      download: (
        <a href={reportHref + item}>
          <Button
            iconCategory="utility"
            iconName="download"
            iconPosition="left"
          />
        </a>
      ),
      id: item
    }));
  }

  header(items) {
    const count = items ? items.length : 0;
    return (
      <div className="report-header">
        <h2>
          <FormattedMessage id="components.ecs.reports.header" />
        </h2>
        <FormattedMessage
          id="components.ecs.catalogs.items"
          values={{ count }}
        />
      </div>
    );
  }

  renderTable(items) {
    const { formatMessage } = this.props.intl;
    return (
      <Card
        className="report-card"
        header={<MediaObject body={this.header(items)} />}
      >
        <DataTable items={items} className="report-list-table" fixedLayout>
          {Object.entries(this.columns()).map((column, index) => {
            const sortable = column[0].sortable;
            const width = column[1].width;
            const property = column[0];
            return (
              <DataTableColumn key={index} sortable={sortable}>
                <CustomDataTableCell
                  property={property}
                  formatMessage={formatMessage}
                  label={this.headerCell(property, formatMessage)}
                  width={width}
                />
              </DataTableColumn>
            );
          })}
        </DataTable>
      </Card>
    );
  }

  drawSpinner(isLoading) {
    return isLoading ? (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    ) : null;
  }

  render() {
    const { reports, isLoading } = this.props;

    return (
      <div className="report-container">
        <React.Fragment>
          {!isLoading ? this.renderTable(this.tableData(reports)) : null}
          {this.drawSpinner(isLoading)}
        </React.Fragment>
      </div>
    );
  }
}

ReportList.contextTypes = {
  router: PropTypes.object
};

ReportList.propTypes = {
  reports: PropTypes.array.isRequired,
  actions: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(ReportList);
